var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78003 7.90625L12.78 3.90625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.443 7.57161H12.4489",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1097 4.23958H9.11569",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.416C0.5 3.032 0.732 1.952 1.196 1.176C1.668 0.392 2.476 0 3.62 0C4.764 0 5.568 0.392 6.032 1.176C6.504 1.952 6.74 3.032 6.74 4.416C6.74 5.816 6.504 6.912 6.032 7.704C5.568 8.488 4.764 8.88 3.62 8.88C2.476 8.88 1.668 8.488 1.196 7.704C0.732 6.912 0.5 5.816 0.5 4.416ZM5.396 4.416C5.396 3.768 5.352 3.22 5.264 2.772C5.184 2.324 5.016 1.96 4.76 1.68C4.504 1.392 4.124 1.248 3.62 1.248C3.116 1.248 2.736 1.392 2.48 1.68C2.224 1.96 2.052 2.324 1.964 2.772C1.884 3.22 1.844 3.768 1.844 4.416C1.844 5.088 1.884 5.652 1.964 6.108C2.044 6.564 2.212 6.932 2.468 7.212C2.732 7.492 3.116 7.632 3.62 7.632C4.124 7.632 4.504 7.492 4.76 7.212C5.024 6.932 5.196 6.564 5.276 6.108C5.356 5.652 5.396 5.088 5.396 4.416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.edea834ba66749ab4fb4f463cff6374d.svg";
export { ForwardRef as ReactComponent };